(()=>{
  const root=document.querySelector('[data-antar-pdp]');
  if(!root)return;

  const variantSource=root.querySelector('[data-antar-pdp-variants]');
  let variants=[];
  try{variants=variantSource?JSON.parse(variantSource.textContent):[]}catch(error){console.error('Antar product variants could not be read',error)}

  const panels=[...root.querySelectorAll('[data-antar-media-panel]')];
  const thumbs=[...root.querySelectorAll('[data-antar-media-thumb]')];
  const imagePanels=panels.filter(panel=>panel.dataset.mediaType==='image');
  const mediaCurrent=root.querySelector('[data-antar-media-current]');
  const mediaLabel=root.querySelector('[data-antar-pdp-media-label]');
  const mediaPrev=root.querySelector('[data-antar-media-prev]');
  const mediaNext=root.querySelector('[data-antar-media-next]');
  const mediaExpand=root.querySelector('[data-antar-media-expand]');
  const mediaStage=root.querySelector('.antar-pdp-media-stage');
  const lightbox=root.querySelector('[data-antar-lightbox]');
  const lightboxImage=root.querySelector('[data-antar-lightbox-image]');
  const lightboxLabel=root.querySelector('[data-antar-lightbox-label]');
  const lightboxCurrent=root.querySelector('[data-antar-lightbox-current]');
  const lightboxTotal=root.querySelector('[data-antar-lightbox-total]');
  let lightboxIndex=0;
  const price=root.querySelector('[data-antar-pdp-price]');
  const compare=root.querySelector('[data-antar-pdp-compare]');
  const availability=root.querySelector('[data-antar-pdp-availability]');
  const variantInput=root.querySelector('[data-antar-pdp-variant-id]');
  const addButton=root.querySelector('[data-antar-pdp-add]');
  const addLabel=root.querySelector('[data-antar-pdp-add-label]');
  const addPrice=root.querySelector('[data-antar-pdp-add-price]');
  const mobilePrice=root.querySelector('[data-antar-mobile-price]');
  const mobileAdd=root.querySelector('[data-antar-mobile-add]');
  const purchaseRow=root.querySelector('.antar-pdp-purchase-row');
  const mobileBar=root.querySelector('[data-antar-pdp-mobile-bar]');
  const quantityInput=root.querySelector('[data-antar-qty-input]');
  const addedValue=root.querySelector('[data-antar-pdp-added-value]');
  const accessBenefit=root.querySelector('[data-antar-access-benefit]');
  const accessGiftable=root.querySelector('[data-antar-access-giftable]');
  const accessSection=root.querySelector('[data-antar-access-section]');
  const accessSectionValue=root.querySelector('[data-antar-access-section-value]');
  const accessSectionGiftable=root.querySelector('[data-antar-access-section-giftable]');
  const reduce=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  const normalizeUrl=value=>{
    try{return new URL(value,window.location.origin).pathname+new URL(value,window.location.origin).search}catch(error){return value||''}
  };

  const activePanel=()=>panels.find(panel=>panel.classList.contains('is-active'))||panels[0]||null;

  const syncLightbox=panel=>{
    if(!lightbox||!lightboxImage||!panel||panel.dataset.mediaType!=='image')return false;
    const image=panel.querySelector('[data-antar-media-main]');
    if(!image)return false;
    const index=imagePanels.indexOf(panel);
    lightboxIndex=index<0?0:index;
    lightboxImage.src=image.currentSrc||image.src;
    lightboxImage.alt=image.alt||'';
    if(lightboxCurrent)lightboxCurrent.textContent=String(lightboxIndex+1).padStart(2,'0');
    if(lightboxTotal)lightboxTotal.textContent=String(imagePanels.length).padStart(2,'0');
    if(lightboxLabel)lightboxLabel.textContent=mediaLabel?.textContent||'';
    return true;
  };

  const activateMedia=({id=null,src=null,syncVariant=false}={})=>{
    if(!panels.length)return;
    let target=null;
    if(id)target=panels.find(panel=>String(panel.dataset.mediaId)===String(id));
    if(!target&&src){
      const normalized=normalizeUrl(src);
      target=panels.find(panel=>normalizeUrl(panel.dataset.mediaSrc)===normalized);
    }
    if(!target)return;
    const targetId=target.dataset.mediaId;
    panels.forEach(panel=>{
      const active=panel===target;
      panel.classList.toggle('is-active',active);
      panel.hidden=!active;
      if(!active)panel.querySelector('video')?.pause();
    });
    thumbs.forEach(thumb=>{
      const active=String(thumb.dataset.mediaId)===String(targetId);
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-pressed',String(active));
      if(active){
        if(mediaCurrent)mediaCurrent.textContent=String(thumb.dataset.mediaIndex||1).padStart(2,'0');
        thumb.scrollIntoView({behavior:reduce?'auto':'smooth',block:'nearest',inline:'nearest'});
      }
    });
    if(mediaExpand)mediaExpand.hidden=target.dataset.mediaType!=='image';
    if(lightbox?.open&&target.dataset.mediaType==='image')syncLightbox(target);
    if(syncVariant)syncVariantFromMedia(target);
  };

  const stepMedia=delta=>{
    if(panels.length<2)return;
    const current=activePanel();
    const index=Math.max(0,panels.indexOf(current));
    const next=(index+delta+panels.length)%panels.length;
    activateMedia({id:panels[next].dataset.mediaId,src:panels[next].dataset.mediaSrc,syncVariant:true});
  };

  const stepLightbox=delta=>{
    if(!imagePanels.length)return;
    lightboxIndex=(lightboxIndex+delta+imagePanels.length)%imagePanels.length;
    const panel=imagePanels[lightboxIndex];
    activateMedia({id:panel.dataset.mediaId,src:panel.dataset.mediaSrc,syncVariant:true});
    syncLightbox(panel);
  };

  const openLightbox=()=>{
    const panel=activePanel();
    if(!syncLightbox(panel)||!lightbox)return;
    if(typeof lightbox.showModal==='function')lightbox.showModal();
    else lightbox.setAttribute('open','');
    requestAnimationFrame(()=>root.querySelector('[data-antar-lightbox-close]')?.focus());
  };

  const closeLightbox=()=>{
    if(!lightbox)return;
    if(typeof lightbox.close==='function'&&lightbox.open)lightbox.close();
    else lightbox.removeAttribute('open');
  };

  thumbs.forEach(thumb=>thumb.addEventListener('click',()=>activateMedia({id:thumb.dataset.mediaId,src:thumb.dataset.mediaSrc,syncVariant:true})));
  mediaPrev?.addEventListener('click',()=>stepMedia(-1));
  mediaNext?.addEventListener('click',()=>stepMedia(1));
  mediaExpand?.addEventListener('click',openLightbox);
  root.querySelectorAll('[data-antar-media-main]').forEach(image=>image.addEventListener('click',openLightbox));
  root.querySelector('[data-antar-lightbox-close]')?.addEventListener('click',closeLightbox);
  root.querySelector('[data-antar-lightbox-prev]')?.addEventListener('click',()=>stepLightbox(-1));
  root.querySelector('[data-antar-lightbox-next]')?.addEventListener('click',()=>stepLightbox(1));
  lightbox?.addEventListener('click',event=>{if(event.target===lightbox)closeLightbox()});
  lightbox?.addEventListener('cancel',event=>{event.preventDefault();closeLightbox()});

  document.addEventListener('keydown',event=>{
    if(!lightbox?.open)return;
    if(event.key==='ArrowLeft'){event.preventDefault();stepLightbox(-1)}
    if(event.key==='ArrowRight'){event.preventDefault();stepLightbox(1)}
  });

  const addSwipeNavigation=(element,callback)=>{
    if(!element)return;
    let startX=null;
    element.addEventListener('pointerdown',event=>{if(event.pointerType==='mouse')return;startX=event.clientX},{passive:true});
    element.addEventListener('pointerup',event=>{
      if(startX===null)return;
      const distance=event.clientX-startX;
      startX=null;
      if(Math.abs(distance)<44)return;
      callback(distance>0?-1:1);
    },{passive:true});
    element.addEventListener('pointercancel',()=>{startX=null},{passive:true});
  };
  addSwipeNavigation(mediaStage,stepMedia);
  addSwipeNavigation(root.querySelector('.antar-pdp-lightbox-stage'),stepLightbox);

  const touchLayout=window.matchMedia?.('(max-width: 820px)').matches;
  const bindMobileHoverRail=(track,itemSelector)=>{
    if(!touchLayout||!track)return;
    const cards=[...track.querySelectorAll(itemSelector)];
    if(!cards.length)return;
    let frame=0;
    const sync=()=>{
      frame=0;
      if(track.scrollWidth<=track.clientWidth+4){cards.forEach(card=>card.classList.remove('is-mobile-active'));return;}
      const trackRect=track.getBoundingClientRect();
      if(trackRect.bottom<=0||trackRect.top>=window.innerHeight){cards.forEach(card=>card.classList.remove('is-mobile-active'));return;}
      const leftEdge=Math.max(0,trackRect.left);
      const rightEdge=Math.min(window.innerWidth,trackRect.right);
      let winner=null,best=-1;
      cards.forEach(card=>{
        const rect=card.getBoundingClientRect();
        const visible=Math.max(0,Math.min(rect.right,rightEdge)-Math.max(rect.left,leftEdge));
        const ratio=visible/Math.max(1,rect.width);
        if(ratio>best){best=ratio;winner=card;}
      });
      cards.forEach(card=>card.classList.toggle('is-mobile-active',card===winner&&best>.18));
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(sync);};
    track.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    cards.forEach(card=>{
      card.addEventListener('pointerdown',event=>{
        if(event.pointerType==='mouse')return;
        cards.forEach(item=>item.classList.remove('is-mobile-active'));
        card.classList.add('is-mobile-active','is-mobile-pressed');
      },{passive:true});
      const release=()=>{card.classList.remove('is-mobile-pressed');schedule();};
      card.addEventListener('pointerup',release,{passive:true});
      card.addEventListener('pointercancel',release,{passive:true});
      card.addEventListener('pointerleave',release,{passive:true});
    });
    requestAnimationFrame(sync);
  };

  bindMobileHoverRail(root.querySelector('.antar-pdp-related-grid'),'.antar-pdp-related-card');
  const accessCarousel=root.querySelector('[data-antar-access-carousel]');
  bindMobileHoverRail(accessCarousel,'.antar-pdp-antar-access-feature');

  if(touchLayout&&accessCarousel&&!reduce){
    const accessCards=[...accessCarousel.querySelectorAll('.antar-pdp-antar-access-feature')];
    let accessTimer=0;
    let accessVisible=false;
    let accessPressed=false;
    const currentAccessIndex=()=>{
      const center=accessCarousel.getBoundingClientRect().left+(accessCarousel.clientWidth/2);
      let winner=0,best=Infinity;
      accessCards.forEach((card,index)=>{
        const rect=card.getBoundingClientRect();
        const distance=Math.abs((rect.left+(rect.width/2))-center);
        if(distance<best){best=distance;winner=index;}
      });
      return winner;
    };
    const clearAccessTimer=()=>{window.clearTimeout(accessTimer);accessTimer=0;};
    const scheduleAccessAdvance=()=>{
      clearAccessTimer();
      if(!accessVisible||accessPressed||document.visibilityState==='hidden'||accessCards.length<2)return;
      accessTimer=window.setTimeout(()=>{
        const next=(currentAccessIndex()+1)%accessCards.length;
        const card=accessCards[next];
        const left=card.offsetLeft-((accessCarousel.clientWidth-card.clientWidth)/2);
        accessCarousel.scrollTo({left:Math.max(0,left),behavior:'smooth'});
        scheduleAccessAdvance();
      },3800);
    };
    if('IntersectionObserver'in window){
      const accessObserver=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          accessVisible=entry.isIntersecting&&entry.intersectionRatio>=.28;
          scheduleAccessAdvance();
        });
      },{threshold:[0,.28,.55]});
      accessObserver.observe(accessCarousel);
    }else{accessVisible=true;scheduleAccessAdvance();}
    accessCarousel.addEventListener('pointerdown',event=>{
      if(event.pointerType==='mouse')return;
      accessPressed=true;
      clearAccessTimer();
    },{passive:true});
    const releaseAccess=()=>{accessPressed=false;scheduleAccessAdvance();};
    accessCarousel.addEventListener('pointerup',releaseAccess,{passive:true});
    accessCarousel.addEventListener('pointercancel',releaseAccess,{passive:true});
    accessCarousel.addEventListener('scroll',()=>{
      if(accessPressed)return;
      clearAccessTimer();
      accessTimer=window.setTimeout(scheduleAccessAdvance,650);
    },{passive:true});
    document.addEventListener('visibilitychange',scheduleAccessAdvance);
  }

  if(touchLayout&&mediaStage){
    const setGalleryActive=active=>mediaStage.classList.toggle('is-mobile-active',active);
    if('IntersectionObserver'in window){
      const galleryObserver=new IntersectionObserver(entries=>entries.forEach(entry=>setGalleryActive(entry.isIntersecting&&entry.intersectionRatio>=.32)),{threshold:[0,.32,.55,.8]});
      galleryObserver.observe(mediaStage);
    }else setGalleryActive(true);
    mediaStage.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse')mediaStage.classList.add('is-mobile-active','is-mobile-pressed')},{passive:true});
    const releaseGallery=()=>mediaStage.classList.remove('is-mobile-pressed');
    mediaStage.addEventListener('pointerup',releaseGallery,{passive:true});
    mediaStage.addEventListener('pointercancel',releaseGallery,{passive:true});
    mediaStage.addEventListener('pointerleave',releaseGallery,{passive:true});
  }

  const selectedOptions=()=>[...root.querySelectorAll('[data-antar-pdp-option-group]')]
    .sort((a,b)=>Number(a.dataset.position)-Number(b.dataset.position))
    .map(group=>group.querySelector('[data-antar-pdp-option]:checked')?.value||'');

  const getVariant=()=>{
    if(!variants.length)return null;
    const selected=selectedOptions();
    if(!selected.length)return variants[0];
    return variants.find(variant=>variant.options.length===selected.length&&variant.options.every((value,index)=>value===selected[index]))||null;
  };

  const normalizeMediaDescriptor=value=>{
    let text=String(value||'');
    try{text=decodeURIComponent(text)}catch(error){}
    return ` ${text.toLowerCase().replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim()} `;
  };

  const mediaDescriptor=panel=>{
    if(!panel)return '';
    const media=panel.querySelector('[data-antar-media-main]');
    return [panel.dataset.mediaSrc||'',media?.getAttribute('src')||'',media?.getAttribute('alt')||''].join(' ');
  };

  const matchMediaOption=(group,descriptor)=>{
    const values=[...group.querySelectorAll('[data-antar-pdp-option]')].map(input=>input.value).filter(Boolean);
    if(!values.length)return null;
    const normalized=normalizeMediaDescriptor(descriptor);
    const compact=normalized.replace(/\s+/g,'');
    const packMatch=values.find(value=>{
      const match=String(value).match(/pack\s+of\s+(\d+)/i);
      if(!match)return false;
      const size=match[1];
      return compact.includes(`${size}pack`)||compact.includes(`packof${size}`)||compact.includes(`pack${size}`);
    });
    if(packMatch)return packMatch;
    return values.find(value=>{
      const token=normalizeMediaDescriptor(value).trim();
      if(!token||/^pack\s+of\s+\d+$/i.test(String(value).trim()))return false;
      return normalized.includes(` ${token} `);
    })||null;
  };

  const syncVariantFromMedia=panel=>{
    const descriptor=mediaDescriptor(panel);
    if(!descriptor)return false;
    let changed=false;
    root.querySelectorAll('[data-antar-pdp-option-group]').forEach(group=>{
      const value=matchMediaOption(group,descriptor);
      if(!value)return;
      const input=[...group.querySelectorAll('[data-antar-pdp-option]')].find(item=>item.value===value);
      if(!input||input.checked)return;
      input.checked=true;
      changed=true;
    });
    if(!changed)return false;
    updateVariant({preserveMedia:true});
    return true;
  };

  const syncOptionLegends=()=>{
    root.querySelectorAll('[data-antar-pdp-option-group]').forEach(group=>{
      const selected=group.querySelector('[data-antar-pdp-option]:checked')?.value||'';
      const output=group.querySelector('[data-antar-option-selected]');
      if(output)output.textContent=selected;
    });
  };

  const syncOptionAvailability=()=>{
    const selected=selectedOptions();
    root.querySelectorAll('[data-antar-pdp-option-group]').forEach(group=>{
      const index=Math.max(0,Number(group.dataset.position||1)-1);
      group.querySelectorAll('[data-antar-pdp-option]').forEach(input=>{
        const candidate=[...selected];
        candidate[index]=input.value;
        const candidateVariant=variants.find(item=>item.options.length===candidate.length&&item.options.every((value,optionIndex)=>value===candidate[optionIndex]));
        const unavailable=Boolean(candidateVariant&&!candidateVariant.available);
        const label=input.nextElementSibling;
        label?.classList.toggle('is-unavailable',unavailable);
        label?.setAttribute('aria-disabled',String(unavailable));
        input.disabled=unavailable&&!input.checked;
      });
    });
  };

  const formatAccess=access=>{
    if(!access?.valid)return '';
    const days=Number(access.days);
    const units=Number(access.units);
    if(!Number.isFinite(days)||days<1||!Number.isFinite(units)||units<1)return '';
    if(units===1)return `${days} ${days===1?'day':'days'} inside Antar`;
    return `${units} × ${days}-day Antar passes`;
  };

  const syncAccessBenefit=variant=>{
    const access=variant?.antarAccess;
    const label=formatAccess(access);
    const valid=Boolean(label);
    const fallback=root.classList.contains('antar-pdp--rakhi')?'Handcrafted with purpose':'Free delivery across India';
    if(addedValue)addedValue.textContent=valid?label:fallback;
    if(accessBenefit){
      accessBenefit.hidden=!valid;
      const benefitText=accessBenefit.querySelector('[data-antar-access-benefit-text]');
      if(benefitText)benefitText.textContent=valid?label:'';
    }
    if(accessGiftable)accessGiftable.hidden=!(valid&&access?.giftable);
    if(accessSection)accessSection.hidden=!valid;
    if(accessSectionValue)accessSectionValue.textContent=valid?label:'';
    if(accessSectionGiftable)accessSectionGiftable.hidden=!(valid&&access?.giftable);
  };

  const updateVariant=({preserveMedia=false}={})=>{
    const variant=getVariant();
    syncOptionLegends();
    syncOptionAvailability();
    syncAccessBenefit(variant);
    if(!variant){
      if(addButton)addButton.disabled=true;
      if(addLabel)addLabel.textContent='Combination unavailable';
      if(addPrice)addPrice.textContent='';
      if(mobileAdd){mobileAdd.disabled=true;mobileAdd.textContent='Unavailable'}
      return;
    }

    if(variantInput)variantInput.value=variant.id;
    if(price)price.textContent=variant.price||'';
    if(mobilePrice)mobilePrice.textContent=variant.price||'';
    if(compare){compare.textContent=variant.compareAt||'';compare.hidden=!variant.compareAt}
    if(availability){
      availability.textContent=variant.available?'Available':'Sold out';
      availability.classList.toggle('is-unavailable',!variant.available);
    }
    if(addButton)addButton.disabled=!variant.available;
    if(addLabel)addLabel.textContent=variant.available?'Add to bag':'Sold out';
    if(addPrice)addPrice.textContent=variant.available?(variant.price||''):'';
    if(mobileAdd){mobileAdd.disabled=!variant.available;mobileAdd.textContent=variant.available?'Add to bag':'Sold out'}
    if(mediaLabel&&variant.label&&variant.label!=='Default Title')mediaLabel.textContent=variant.label;
    if(lightboxLabel&&variant.label&&variant.label!=='Default Title')lightboxLabel.textContent=variant.label;

    if(!preserveMedia)activateMedia({id:variant.mediaId,src:variant.mediaSrc});

    if(variant.url&&window.history?.replaceState){
      const url=new URL(window.location.href);
      url.searchParams.set('variant',variant.id);
      window.history.replaceState({},'',url);
    }
  };

  root.addEventListener('change',event=>{
    if(event.target.matches('[data-antar-pdp-option]'))updateVariant();
  });

  root.querySelector('[data-antar-qty-minus]')?.addEventListener('click',()=>{
    if(!quantityInput)return;
    quantityInput.value=String(Math.max(1,(Number(quantityInput.value)||1)-1));
    quantityInput.dispatchEvent(new Event('change',{bubbles:true}));
  });
  root.querySelector('[data-antar-qty-plus]')?.addEventListener('click',()=>{
    if(!quantityInput)return;
    quantityInput.value=String(Math.max(1,(Number(quantityInput.value)||1)+1));
    quantityInput.dispatchEvent(new Event('change',{bubbles:true}));
  });
  quantityInput?.addEventListener('change',()=>{quantityInput.value=String(Math.max(1,Number(quantityInput.value)||1))});

  mobileAdd?.addEventListener('click',()=>{
    if(addButton&&!addButton.disabled)addButton.click();
  });

  if(mobileBar&&purchaseRow&&'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        const passedAbove=!entry.isIntersecting&&entry.boundingClientRect.bottom<0;
        mobileBar.classList.toggle('is-visible',passedAbove);
      });
    },{threshold:.08});
    observer.observe(purchaseRow);
  }

  root.querySelector('[data-antar-pdp-share]')?.addEventListener('click',async event=>{
    const button=event.currentTarget;
    const label=button.querySelector('[data-antar-share-label]');
    const shareData={title:document.title,url:window.location.href};
    try{
      if(navigator.share){await navigator.share(shareData);return}
      await navigator.clipboard.writeText(window.location.href);
      if(label){label.textContent='Link copied';setTimeout(()=>label.textContent='Share',1600)}
    }catch(error){}
  });

  root.querySelectorAll('.antar-pdp-detail-list details').forEach(detail=>{
    detail.addEventListener('toggle',()=>{
      if(!detail.open)return;
      root.querySelectorAll('.antar-pdp-detail-list details').forEach(other=>{if(other!==detail)other.open=false});
    });
  });

  updateVariant();
  activateMedia({id:activePanel()?.dataset.mediaId,src:activePanel()?.dataset.mediaSrc});
})();
